import { formatDate } from '../bs-moment/format';
var DateFormatter = (function () {
    function DateFormatter() {
    }
    DateFormatter.prototype.format = function (date, format, locale) {
        return formatDate(date, format, locale);
    };
    return DateFormatter;
}());
export { DateFormatter };
//# sourceMappingURL=date-formatter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/date-formatter.js
// module id = 572
// module chunks = 0